import React, { useState,useEffect } from "react";
import {
  Box,
  Card,
  Typography,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import { Colors } from "../utils/colors";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsAuthenticated,
  setAccessToken,
  setUser,
} from "../Redux/Reducers/appState";
import { AuthService } from "../services/auth/Auth";
import axios from 'axios'
import { broadcastUserLogout } from "../utils/userSessionTimeout";

export default function Logout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
   const user = useSelector((data)=>data.appState.user)

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [ipaddress, setIPAdress] = useState("");
  useEffect(() => { 
     
    const fetchIpAddress = async()=>{
       try { 
         const res = await axios.get('https://ipapi.co/json/')
        setIPAdress(res.data.ip); 
       } catch (error) { 
          alert(error)
        } 
        }
         fetchIpAddress(); 
         }, []); 

  const handleLogout = async () => {
    setLoading(true);
    setErrorMsg("");

    try {
      const formData = {
        id: user?.id || null,
        email: user?.email || null,
        ipaddress: ipaddress
      };

      await AuthService.logout(formData);

      dispatch(setUser(null));
      dispatch(setAccessToken(null));
      dispatch(setIsAuthenticated(false));
      broadcastUserLogout({ reason: "manual" });

      navigate("/login", { replace: true });
    } catch (error) {
      console.log(error);
      setErrorMsg("Unable to communicate with server. Please try again.");
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: Colors.secondary,
        p: 3,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: Colors.text,
      }}
    >
      <Card
        sx={{
          p: 4,
          borderRadius: 2,
          width: "100%",
          maxWidth: 400,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h5"
          fontWeight={700}
          sx={{ mb: 2, color: Colors.accent }}
        >
          Logout
        </Typography>

        <Typography sx={{ mb: 3, color: Colors.muted }}>
          Are you sure you want to log out of your account?
        </Typography>

        {errorMsg && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMsg}
          </Alert>
        )}

        <Button
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: Colors.accent,
            color: "white",
            fontWeight: 700,
            mb: 2,
          }}
          disabled={loading}
          onClick={handleLogout}
        >
          {loading ? (
            <CircularProgress size={24} sx={{ color: "white" }} />
          ) : (
            "Logout"
          )}
        </Button>

        <Button
          fullWidth
          variant="outlined"
          sx={{
            borderColor: Colors.accent,
            color: Colors.accent,
            fontWeight: 600,
          }}
          disabled={loading}
          onClick={() => navigate(-1)}
        >
          Cancel
        </Button>
      </Card>
    </Box>
  );
}
